/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import IconClose from 'assets/images/svg/icon-close.svg';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './modal-select.scss';

const Modal: React.FC<any> = (props: any) => {
  const {
    children,
    onClose,
    hasClose,
    isOpen,
    className = '',
    modalRef,
  } = props;
  const [modalContainer] = useState(document.createElement('div'));

  useEffect(() => {
    let modalId = document.getElementById('modal-root');

    if (!modalId) {
      const tempEl = document.createElement('div');
      tempEl.id = 'modal-root';
      document.body.append(tempEl);
      modalId = tempEl;
    }

    modalId.appendChild(modalContainer);

    return function cleanup() {
      modalId?.removeChild(modalContainer);
    };
  }, []);

  return isOpen
    ? ReactDOM.createPortal(
        <div
          data-testid="modal-overlay-select"
          className={`modal-overlay-select ${className || ''}`}
        >
          <div data-testid="modal-body" className="modal-body" ref={modalRef}>
            {hasClose && (
              <div className="modal-close">
                <span>Cerrar</span>
                <span className="icon-close" onClick={onClose}>
                  <img src={IconClose} alt="icon" />
                </span>
              </div>
            )}
            {children}
          </div>
        </div>,
        modalContainer,
      )
    : null;
};

export default Modal;
